function setCookie(name: string, value: string, days: number) {
  let expires = '';
  if (days) {
    const date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = `; expires=${date.toUTCString()}`;
  }
  document.cookie = `${name}=${value || ''}${expires}; path=/`;
}

function getCookie(name: string): string | null {
  try {
    const nameEQ = `${name}=`;
    const ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i += 1) {
      let c = ca[i];
      while (c.charAt(0) === ' ') c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  } catch (e) {
    return null;
  }
}

function removeCookie(name: string): boolean {
  try {
    setCookie(name, '', -999999);
    return true;
  } catch (e) {
    return false;
  }
}

function formattingPhoneNumber(phoneNumber: string):Array<string>{
  let data = phoneNumber.split('');
  data.splice(0,0, '+');
  data.splice(2,0, ' (');
  data.splice(6,0, ') ');
  data.splice(10,0, '-');
  data.splice(13,0, '-');

  return data;
}

const objectKeys = Object.keys as <T>(o: T) => Extract<keyof T, string>[];

export { setCookie, getCookie, removeCookie, formattingPhoneNumber, objectKeys };
